module.exports = __webpack_public_path__ + "assets/close-index.e4cbc36a.svg";